module.exports = __webpack_public_path__ + "media/images/company/company_01_03-84abbc5b3027e95006c2cd6306ff90b1.jpg";